import { ApproachBulletSegment, approachPanels } from 'constants/BrandAssessmentConstants'

const renderSegment = (segment: ApproachBulletSegment, index: number) =>
  'dots' in segment ? (
    <span className="approach-inline-dots" key={index}>
      {segment.dots.map((color, dotIndex) => (
        <span key={dotIndex} className={`approach-dot approach-dot-${color}`} />
      ))}
    </span>
  ) : (
    <span key={index} className={segment.bold ? 'font-bold' : undefined}>
      {segment.text}
    </span>
  )

export const TheApproachPanels = () => {
  return (
    <div className="approach-table">
      {approachPanels.map(panel => (
        <div key={panel.key} className={`approach-column panel-${panel.key}`}>
          <div className="approach-header-cell">
            <span className="subtitle-xs approach-header-title">{panel.title}</span>
            <div className="approach-header-threshold">
              <span className="subtitle-xs">{panel.threshold.label}</span>
              {panel.threshold.dotColors.map((color, index) => (
                <span key={index} className={`approach-dot approach-dot-${color}`} />
              ))}
            </div>
          </div>
          <div className="approach-body-cell">
            <ul className="approach-panel-bullets">
              {panel.bullets.map((bullet, index) => (
                <li key={index} className="body-xs">
                  {bullet.segments.map(renderSegment)}
                  {bullet.subBullets && (
                    <ul className="approach-panel-sub-bullets">
                      {bullet.subBullets.map(sub => (
                        <li key={sub} className="body-xs">
                          {sub}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}
